module.exports = __webpack_public_path__ + "static/media/reminderToJoin.1e583ed5.svg";